<template>
  <div id="checkout">
    <Header />
    <CheckoutCartV2 />
    <!-- Antiga página de Checkout -->
    <!-- <CheckoutCart /> -->
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/template/Header";
// import CheckoutCart from "@/components/checkout/CheckoutCart";
import CheckoutCartV2 from "@/components/checkout/CheckoutCartV2";
import Footer from "@/components/template/Footer";

export default {
  data() {
    return {
      linkDaPagina: null,
    };
  },

  async created() {
    this.linkDaPagina = window.location.href;
    window.scrollTo(0,0);
  },

  metaInfo() {
    return {
      title: "Finalizar Compra | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "Faça sua compra no Leveros Integra e ganhe 5% de desconto em compras à vista.",
        },
        { name: "robots", content: "noindex,nofollow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: "Finalizar Compra | Leveros Integra",
        },
        {
          property: "og:description",
          content:
            "Faça sua compra no Leveros Integra e ganhe 5% de desconto em compras à vista.",
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
  components: {
    // CheckoutCart,
    Header,
    Footer,
    CheckoutCartV2
  },
};
</script>